import React, { FC, useMemo } from 'react';
import { useTheme } from 'styled-components';

import { TOTAL_STEPS } from '@/helpers/auth';

import { ScFormNavigation, ScFormNavigationItem, StatusItem } from '../styled';

const steps = Array.apply(null, Array(TOTAL_STEPS)).map((_, index) => index);

interface FormNavigationProps {
  currentStep: string;
  withMarginBottom?: boolean;
}

export const FormNavigation: FC<FormNavigationProps> = ({
  currentStep,
  withMarginBottom = true,
}) => {
  const { images } = useTheme();
  const itemsUpdated = useMemo(() => {
    const currentIndex = steps.findIndex((i) => `step${i + 1}` === currentStep);

    if (currentIndex === -1) return [];

    return [
      ...steps
        .slice(0, currentIndex)
        .map(() => ({ status: StatusItem.COMPLETED })),
      { status: StatusItem.ACTIVE },
      ...steps
        .slice(currentIndex + 1)
        .map(() => ({ status: StatusItem.NOT_ACTIVE })),
      { status: StatusItem.FINISH },
    ];
  }, [currentStep]);

  return (
    <ScFormNavigation withMarginBottom={withMarginBottom}>
      <ul>
        {itemsUpdated.map((item, index) => (
          <li key={index}>
            <ScFormNavigationItem {...item}>
              {item.status !== StatusItem.FINISH && (
                <span className="step">
                  {item.status === StatusItem.COMPLETED ? (
                    <images.checkIcon.component />
                  ) : (
                    index + 1
                  )}
                </span>
              )}
            </ScFormNavigationItem>
          </li>
        ))}
      </ul>
    </ScFormNavigation>
  );
};
